import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TERMS_CONTENT = `
תנאי שימוש ומדיניות פרטיות — נסעתי

עדכון אחרון: מרץ 2025

1. כללי
ברוכים הבאים ל„נסעתי". השימוש באפליקציה ובשירותים הנלווים (כולל אתר האינטרנט) כפוף לתנאים המפורטים במסמך זה. גישה לשירות או שימוש בו מהווים הסכמה לתנאים אלה.

2. תיאור השירות
„נסעתי" היא מערכת לתיעוד נסיעות — מי נהג ברכב ובאיזה זמן. השירות מיועד למשפחות ולעסקים קטנים לצורך ניהול שימוש ברכבים ומעקב אחר נסיעות. השימוש במערכת הוא על אחריות המשתמש בלבד.

3. שימוש מותר
מותר להשתמש בשירות רק למטרות לגיטימיות, בהתאם לרישיון זה, וללא הפרת דין. אסור להעלות מידע כוזב, להפר את פרטיות אחרים, או לנצל את השירות לצורך פעילות בלתי חוקית או פוגענית.

4. חשבון ומשפחה
כדי להשתמש בשירות יש ליצור „משפחה" (קבוצה) או להצטרף אליה באמצעות קוד הזמנה. אתה אחראי לשמור על סודיות קוד ההזמנה ולעדכן מידע מדויק. ניהול חברי המשפחה והרכבים הוא באחריות המשתמשים במשפחה.

5. נתונים ופרטיות
המערכת שומרת נתונים הקשורים לנסיעות (זמני התחלה וסיום, רכב, נהג) ולמשתמשים (שם, תפקיד, טלפון לפי הצורך). הנתונים משמשים להצגת השירות ולדוחות. אנו מכבדים את פרטיות המשתמשים ומנהלים את הנתונים בהתאם למדיניות הפרטיות שלנו.

הצהרת פרטיות (Privacy disclaimer)
• איסוף מידע: אנו אוספים רק מידע הנדרש להפעלת השירות — פרטי משתמש (שם, תפקיד, טלפון אופציונלי), פרטי רכבים ונסיעות (זמנים, נהג, רכב). המידע נשמר על שרתים שבשליטתנו או של ספקי תשתית מהימנים.
• שימוש: המידע משמש אך ורק להפעלת האפליקציה והאתר — תיעוד נסיעות, דוחות והצגת מידע לחברי אותה „משפחה". איננו מוכרים או משכירים את המידע לצדדים שלישיים למטרות שיווק.
• גישה: גישה לנתוני הנסיעות והמשפחה יש רק למשתמשים המחוברים לאותה משפחה (לפי קוד הזמנה). אתה אחראי לשמור על סודיות הקוד.
• אבטחה: אנו נוקטים אמצעים סבירים לאבטחת הנתונים; עם זאת, שידור ואחסון באינטרנט אינם חסינים לחלוטין מסיכונים.
• זכויות: אם תרצה לעדכן או למחוק מידע אישי, ניתן לפנות אלינו. המשך שימוש בשירות מהווה הסכמה לאיסוף ולשימוש במידע כמתואר לעיל ובתנאי השימוש.

6. אי־אחריות
השירות ניתן „כמות שהוא" (AS IS). איננו מתחייבים שהשירות יהיה זמין ללא הפרעה, מדויק או חסין משגיאות. לא תהיה לנו אחריות לנזק עקיף, מיוחד או תוצאתי הנובע משימוש או אי־יכולת שימוש בשירות.

7. שינויים
אנו רשאים לעדכן מעת לעת את תנאי השימוש. המשך שימוש בשירות לאחר פרסום שינויים מהווה הסכמה לגרסה המעודכנת. מומלץ לעיין בתנאים מעת לעת.

8. יצירת קשר
לגבי תנאי שימוש או פרטיות ניתן לפנות אלינו בדוא״ל: nasati.app@gmail.com

בהמשך השימוש באפליקציה ובאתר אתה מאשר שקראת, הבנת ומסכים לתנאים אלה.
`;

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f0fdfa',
    fontFamily: 'system-ui, sans-serif',
    direction: 'rtl',
    textAlign: 'right',
    padding: '24px 16px',
  },
  wrap: {
    maxWidth: 640,
    margin: '0 auto',
  },
  title: {
    color: '#0f766e',
    fontSize: 28,
    fontWeight: 800,
    marginBottom: 24,
  },
  body: {
    color: '#334155',
    fontSize: 16,
    lineHeight: 1.8,
    whiteSpace: 'pre-line',
  },
  back: {
    display: 'inline-block',
    marginBottom: 24,
    color: '#0f766e',
    fontSize: 16,
    fontWeight: 600,
    textDecoration: 'none',
  },
  backHover: { textDecoration: 'underline' },
};

export default function Terms() {
  useEffect(() => {
    document.title = 'תנאי שימוש ומדיניות פרטיות — נסעתי';
    return () => { document.title = 'Nasati'; };
  }, []);

  return (
    <div className="nasati-page nasati-terms" style={styles.page} lang="he" dir="rtl">
      <div style={styles.wrap}>
        <Link to="/" style={styles.back}>← חזרה לדף הבית</Link>
        <h1 style={styles.title}>תנאי שימוש ומדיניות פרטיות</h1>
        <div style={styles.body}>{TERMS_CONTENT.trim()}</div>
        <Link to="/" style={{ ...styles.back, marginTop: 32, display: 'inline-block' }}>← חזרה לדף הבית</Link>
      </div>
    </div>
  );
}
